<!-- eslint-disable no-multi-spaces -->
<!-- eslint-disable no-shadow -->
<template>
  <div>
    <b-row>
      <b-col class="mb-1">
        <b-form-group>
          <b-row>
            <b-col cols="4">
              <b-form-group description="Selecione o CNPJ.">
                <combo-box-client ref="cboxclient" />
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group>
                <b-button
                  variant="primary"
                  type="button"
                  :disabled="!isAdmin"
                  @click="userTable()"
                >
                  Carregar
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-overlay
          :show="show"
          spinner-variant="primary"
          spinner-type="border"
          spinner-large
          rounded="lg"
        >
          <b-table
            ref="btable_users"
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items_users"
            :fields="fields"
          >
            <!-- coluna actions botões Edit e Delete-->
            <template #cell(actions)="row">

              <!-- Action Buttons -->
              <b-button-toolbar>
                <b-button-group size="sm">

                  <!-- Edit Button -->
                  <b-button
                    size="sm"
                    :disabled="!canEdit(row.item)"
                    @click="editUser(row.item, $event.target)"
                  >
                    EDIT
                  </b-button>

                  <!-- Delete Button (comentado) -->
                  <!-- <b-button
                    size="sm"
                    @click.prevent="modalBeforeDel(row.item, $event.target)"
                  >
                    DELETE
                  </b-button> -->
                </b-button-group>
              </b-button-toolbar>
            </template>
          </b-table>
        </b-overlay>

        <!-- Delete Modal  -->
        <div>
          <b-modal
            :id="modalDelete.modalId"
            ref="modal-delete"
            :title="modalDelete.title"
            :content="modalDelete.content"
            button-size="sm"
            hide-footer
          >
            <div>{{ modalDelete.content }}</div>
            <b-col class="demo-inline-spacing">
              <b-button
                size="sm"
                variant="primary"
                type="button"
                @click="hideModal1()"
              >
                Cancelar
              </b-button>

              <b-button
                id="deleteButton"
                size="sm"
                variant="primary"
                type="button"
                @click.prevent="deleteClient()"
              >
                Excluir
              </b-button>
            </b-col>
          </b-modal>
        </div>
      </b-col>

      <b-col cols="12">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </b-col>
    </b-row>

    <!-- ✅ ALTERADO: CLIENT_ADMIN também pode ver e cadastrar usuários -->
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-primary"
      v-if="canRegister"
      @click="addUsersModal()"
    >
      Cadastrar novo usuário
    </b-button>

    <modal-new-users ref="musers" />
    <validate-logon-keycloak ref="validatelogon" />
  </div>
</template>

<script>
import axios from 'axios'
import Ripple from 'vue-ripple-directive'
import ModalNewUsers from '@/views/Users/ModalNewUsers.vue'
import ValidateLogonKeycloak from '@/views/reusable-components/ValidateLogonKeycloak.vue'

import {
  BFormGroup,
  BPagination,
  BButtonToolbar,
  BButtonGroup,
  BOverlay,
  BTable,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import ComboBoxClient from '../reusable-components/ComboBoxClient.vue'

export default {
  name: 'UserKeycloak',
  components: {
    ComboBoxClient,
    ValidateLogonKeycloak,
    BPagination,
    ModalNewUsers,
    BFormGroup,
    BButtonToolbar,
    BButtonGroup,
    BOverlay,
    BTable,
    BRow,
    BCol,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isAdmin: false, // indica se é ADMIN ou CLIENT_ADMIN
      show: false,
      perPage: 10,
      pageOptions: [5, 10, 20, 30],
      totalRows: 1,
      currentPage: 1,
      modalDelete: {
        modalId: 'modalDelete',
        title: '',
        content: 'Excluir',
        id: null,
        cnpj: '',
      },
      fields: [
        { key: 'username', label: 'Username', sortable: true },
        { key: 'firstName', label: 'NOME', sortable: true },
        { key: 'lastName', label: 'Sobrenome', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        {
          key: 'enabled', label: 'status', sortable: true, formatter: value => (value ? 'ativo' : 'inativo'),
        },
        { key: 'actions', label: 'Actions' },
      ],
      items_users: [],
    }
  },
  computed: {
    canRegister() {
      const userRole = JSON.parse(localStorage.getItem('userData')).group.toUpperCase()
      // ✅ ALTERADO: agora CLIENT_ADMIN também pode cadastrar usuários
      return userRole === 'ADMIN' || userRole === 'CLIENT_ADMIN'
    },
  },
  mounted() {
    this.validateUserLogon()
    this.setUser()
  },
  created() {
    this.createUsersTable()
  },
  methods: {
    validateUserLogon() {
      this.$refs.validatelogon.validateLogon()
    },
    setUser() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      this.$parent.$parent.$parent.$refs.adenav.username = userData.fullName
    },
    modalBeforeDel(item, button) {
      this.modalDelete.userCnpj = item.attributes.CNPJ[0] || ''
      this.modalDelete.title = 'Deletar Usuário'
      this.modalDelete.content = 'Tem certeza que deseja excluir este usuário?'
      this.$root.$emit('bv::show::modal', this.$refs['modal-delete'].id, button)
    },
    hideModal1() {
      this.$refs['modal-delete'].hide()
    },
    toast(toaster, append = false, variant, message, title) {
      this.$bvToast.toast(message, {
        title, toaster, solid: true, appendToast: append, variant,
      })
    },
    opcaoTodos() {
      const selectedCnpj = this.$refs.cboxclient.selected
      if (selectedCnpj === 'todos') {
        this.createUsersTable()
        console.log('chamou createUsersTable')
      }
    },

    async createUsersTable() {
      this.show = true
      this.isBusy = true

      const userRole = JSON.parse(localStorage.getItem('userData')).group.toUpperCase()

      // ✅ ALTERADO: OPERATOR não tem acesso total, apenas vê ele mesmo
      this.isAdmin = userRole === 'ADMIN' || userRole === 'CLIENT_ADMIN'

      const CNPJValue = JSON.parse(localStorage.getItem('userData')).cnpj
      console.log(CNPJValue)

      try {
        const res = await axios.post('/auth/getusers', CNPJValue)
        let data = res.data

        if (userRole === 'OPERATOR') {
          const { username } = JSON.parse(localStorage.getItem('userData'))
          data = data.filter(item => item.username === username)
        }

        this.items_users = data
        this.totalRows = this.items_users.length
        this.currentPage = 1
      } catch (error) {
        console.log('Erro ao carregar usuários:', error)
      }

      this.isBusy = false
      this.show = false
    },

    async userTable() {
      this.show = true
      this.opcaoTodos()

      try {
        const CNPJValue = JSON.parse(localStorage.getItem('userData')).cnpj
        const res = await axios.post('/auth/getusers', CNPJValue)
        let data = res.data

        const selectedCnpj = this.$refs.cboxclient.selected
        if (!selectedCnpj) {
          this.toast('b-toaster-top-right', true, 'danger', 'Selecione um cliente!', 'Erro de usabilidade')
          throw new Error('Selecione um cliente!')
        }

        // Filtra pelo CNPJ selecionado
        data = data.filter(item => item.attributes && item.attributes.CNPJ && item.attributes.CNPJ[0] === selectedCnpj)

        // ✅ ALTERADO: OPERATOR só vê ele mesmo
        const userRole = JSON.parse(localStorage.getItem('userData')).group.toUpperCase()
        const { username } = JSON.parse(localStorage.getItem('userData'))
        if (userRole === 'OPERATOR') {
          data = data.filter(item => item.username === username)
        }

        this.items_users = data
        this.totalRows = data.length
        this.currentPage = 1
      } catch (error) {
        console.log('Erro ao carregar usuários:', error)
      }

      this.show = false
    },

    async addUsersModal(button) {
      const userRole = JSON.parse(localStorage.getItem('userData')).group.toUpperCase()

      // ✅ ALTERADO: ADMIN e CLIENT_ADMIN podem abrir modal
      if (userRole === 'OPERATOR') return

      await this.$refs.musers.getClient()

      // ✅ ALTERADO: CLIENT_ADMIN agora pode editar todos os campos, não apenas senha
      this.$refs.musers.readonly = false
      this.$refs.musers.usersModal.title = 'Cadastro de Usuário'
      this.$refs.musers.registerButton.content = 'Cadastrar'
      this.$refs.musers.itemUsername = ''
      this.$refs.musers.itemEmail = ''
      this.$refs.musers.itemFirstName = ''
      this.$refs.musers.itemLastName = ''
      this.$refs.musers.itemCnpj = ''
      this.$refs.musers.itemSelected = ''
      this.$refs.musers.itemPasswd = ''

      this.$root.$emit('bv::show::modal', this.$refs.musers.usersModal.id, button)
    },

    async editUser(item, button) {
      const userRole = JSON.parse(localStorage.getItem('userData')).group.toUpperCase()

      // ✅ ALTERADO: OPERATOR não pode editar
      if (userRole === 'OPERATOR') return

      await this.$refs.musers.getClient()

      // ✅ ALTERADO: CLIENT_ADMIN agora pode editar todos os campos
      this.$refs.musers.readonly = false

      this.$refs.musers.usersModal.title = `${item.id}`
      this.$refs.musers.registerButton.content = 'Atualizar'
      this.$refs.musers.itemUsername = item.username
      this.$refs.musers.itemEmail = item.email
      this.$refs.musers.itemFirstName = item.firstName
      this.$refs.musers.itemLastName = item.lastName
      // Usuários antigos podem não ter CNPJ/ROLE: abre o modal com os campos vazios
      const attrs = item.attributes || {}
      this.$refs.musers.itemCnpj = (attrs.CNPJ || []).map(cnpj => ({ value: cnpj, label: cnpj }))
      this.$refs.musers.itemSelected = (attrs.ROLE || [])[0] || ''
      this.$refs.musers.itemPasswd = item.user_password

      this.$root.$emit('bv::show::modal', this.$refs.musers.usersModal.id, button)
    },

    canEdit() {
      const userRole = JSON.parse(localStorage.getItem('userData')).group.toUpperCase()
      // ✅ ALTERADO: ADMIN e CLIENT_ADMIN podem editar
      return userRole === 'ADMIN' || userRole === 'CLIENT_ADMIN'
    },
  },
}
</script>
